module.exports = __webpack_public_path__ + "static/media/293871.b6b9e458.png";